import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '25px',
  color: '#ffffff',
  fontSize: '14px',
  fillRule: 'evenodd',
  textTransform: 'none',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  fontWeight: 'bold',
  padding: '15px 25px',
  '&:hover': {
    backgroundColor: '#36899f',
    boxShadow: 'none',
  },
  boxShadow: 'none',
}));

const GlobalButton = styled(CustomButton)(({ theme }) => ({
  background: 'rgba(255,255,255,0.09803921568627451 )',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  background: '#ddb930',
  '&:hover': {
    backgroundColor: '#ddb930',
  },
}));

const SkyButton = styled(CustomButton)(({ theme }) => ({
  background: '#36899f',
  '&:hover': {
    backgroundColor: '#36899f',
  },
}));

interface copyToClickButtonProps {
  color?: string;
  text: string;
  isClicked?: boolean;
  style?: Object;
}

const CopyToClickButton: React.FC<copyToClickButtonProps> = ({
  color,
  text,
  isClicked,
  style,
}) => {
  const copyIcon = require('assets/icons/copy.svg');
  const [hasCopied, setHasCopied] = React.useState(false);

  function handleCopyToClip(text: string): void {
    navigator.clipboard.writeText(text);
    setHasCopied(true);
    setTimeout(() => {
      setHasCopied(false);
    }, 2000);
  }

  return color === 'yellow' && isClicked === true ? (
    <YellowButton
      variant="contained"
      style={style}
      onClick={() => handleCopyToClip(text)}
    >
      <p
        style={{
          margin: '0px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {hasCopied ? 'Copied to clipboard' : text}
      </p>
      <img
        src={copyIcon.default}
        alt="icon"
        width={'15px'}
        height={'15px'}
        style={{ marginLeft: 'auto' }}
      />
    </YellowButton>
  ) : color === 'sky' && isClicked === true ? (
    <SkyButton
      variant="contained"
      style={style}
      onClick={() => handleCopyToClip(text)}
    >
      <p
        style={{
          margin: '0px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {hasCopied ? 'Copied to clipboard' : text}
      </p>
      <img
        src={copyIcon.default}
        alt="icon"
        width={'15px'}
        height={'15px'}
        style={{ marginLeft: 'auto' }}
      />
    </SkyButton>
  ) : (
    <GlobalButton
      variant="contained"
      style={style}
      onClick={() => handleCopyToClip(text)}
    >
      <p
        style={{
          margin: '0px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {hasCopied ? 'Copied to clipboard' : text}
      </p>
      <img
        src={copyIcon.default}
        alt="icon"
        width={'15px'}
        height={'15px'}
        style={{ marginLeft: 'auto' }}
      />
    </GlobalButton>
  );
};

export default CopyToClickButton;
